import { useContext } from '@/compat';
import { computed } from 'vue';
import { lensPath, view } from 'ramda';

export const useDynamicTranslations = headers => {
  const { $i18n, $lang } = useContext();

  return [
    computed(() => headers.map(item => {
      const path = `${item.langPath}.${item.langKey}`;
      const lens = lensPath(path.split('.'));

      return {
        ...item,
        text: item.text || (item.langPath && item.langKey ? $i18n.t(view(lens, $lang)) : ''),
      };
    })),
  ];
};
